var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPlayCircleFilled = function SvgPlayCircleFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M11.875 21.75a9.5 9.5 0 0 1-3.814-.774 10.1 10.1 0 0 1-3.147-2.14 10.1 10.1 0 0 1-2.14-3.146A9.5 9.5 0 0 1 2 11.875q0-2.023.775-3.805a10.2 10.2 0 0 1 2.13-3.156 10.1 10.1 0 0 1 3.146-2.14A9.5 9.5 0 0 1 11.865 2q2.024 0 3.815.775a10.1 10.1 0 0 1 3.156 2.14Q20.2 6.28 20.976 8.07a9.4 9.4 0 0 1 .774 3.805q0 2.023-.774 3.815a10.1 10.1 0 0 1-2.14 3.146q-1.365 1.365-3.156 2.14a9.4 9.4 0 0 1-3.805.774m-1.84-5.973 5.693-3.35a.59.59 0 0 0 .3-.542q0-.349-.3-.533l-5.692-3.369a.74.74 0 0 0-.659-.058.476.476 0 0 0-.339.484v6.942q0 .357.32.503.33.135.678-.077"
  })));
};
export default SvgPlayCircleFilled;